import { CONFIG } from '@/config';
import { tr } from 'framer-motion/client';
import { use, useEffect, useState } from 'react';

type Rsvp = {
    email: string;
    name: string;
    attending: boolean;
    extraNotes?: string;
};

export const Admin = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [rsvps, setRsvps] = useState<Rsvp[]>([]);

    useEffect(() => {
        document.title = "Admin Page";
        fetch(`${CONFIG.apiBaseUrl}api/v0/admin/responses`, {
            credentials: 'include',
            method: "GET",
        }).then((response) => {
            response.json().then((data) => {
                setRsvps(data);
                setIsLoading(false);
            });
        }).catch(() => {
            console.error("Failed to fetch RSVPs");
            setIsLoading(false);
        });
    }, []);

    return (
        <main className="min-h-screen bg-background font-semi-bold">
            <h1 className="text-4xl text-center pt-20">Admin Page</h1>
            {isLoading ? (
                <p className="text-center mt-10">Loading...</p>
            ) : (
                <div className="max-w-4xl mx-auto mt-10 space-y-6">
                    {rsvps.map((rsvp, index) => (
                        <div key={index} className="p-4 border rounded-lg">
                            <p><strong>Name:</strong> {rsvp.name}</p>
                            <p><strong>Email:</strong> {rsvp.email}</p>
                            <p><strong>Attending:</strong> {rsvp.attending ? 'Yes' : 'No'}</p>
                            {rsvp.extraNotes && (
                                <p><strong>Extra Notes:</strong> {rsvp.extraNotes}</p>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </main>
    );
}
